//
import { get } from 'lodash'
import orderBy from 'lodash/orderBy'
import moment from 'moment'
// dev dependencies
import Vue from 'vue'
import faker from 'faker'
import {getPorts, searchPortsWithAny} from "@/utils/ports";
import getField from "@/utils/getField";
import FlightOrder from "@/models/flightOrder";

let uid = 0
const SIZES = {'xs': 25, 'sm': 30, 'md': 40, 'lg': 50}

function getGroupKey (groupingKeys, item) {
  return groupingKeys ? groupingKeys.map(key => get(item, key)).join('_') : ''
}
function getGroupData (groupingKeys, item, gIdx) {
  return groupingKeys.reduce(function (obj, key) {
    obj[key] = get(item, key)
    return obj
  }, {gIdx})
}
export function getItemSize (size) {
  return (size && SIZES[size]) || SIZES.md
}

// export function getOrdersData (count, groupingKeys = []) {
/**
 *
 * @param flightOrders
 * @param groupingKeys nullable
 * @param size: Array ['xs', 'sm', 'md', 'lg']
 * @returns {{groups: Array, items: Array}}
 */
export function groupFlightOrders (flightOrders, groupingKeys, groupingOrders, size = 'md') {
  const itemSize = getItemSize(size)

  let groups = {}
  const groupedItems = {}
  // indexes used to not store groups with looong keys
  const groupKeyIndexes = {}

  // for (let i = 0; i < flightOrders.length; i++) {
  for (let item of flightOrders) {
    //const item = flightOrders[i]

    const gKey = getGroupKey(groupingKeys, item)
    let gIdx = groupKeyIndexes[gKey]
    if (gIdx === undefined) {
      gIdx = Object.keys(groupKeyIndexes).length
      groupKeyIndexes[gKey] = gIdx
      groups[gIdx] = groupingKeys ? getGroupData(groupingKeys, item, gIdx) : {gIdx}
      groupedItems[gIdx] = []
    }
    groupedItems[gIdx].push(item)
  }

  // sort groups by key-fields
  let orderedGroups
  if (groupingKeys) {
    orderedGroups = orderBy(groups, groupingKeys, groupingOrders)
  } else {
    orderedGroups = Object.values(groups)
  }
  let groupIdxList = Object.values(orderedGroups).map(g => g.gIdx)
  // let groupKeys = Object.keys(groups)

  const listGroups = []
  const listItems = []
  let index = 0 // for each items (global index)
  let itemIndex = 0 // for items only (just real items: not groups and not headers)
  let sectionIndex = 0

  let headersIndex = 0

  for (const group of orderedGroups) {
    const groupKey = group.gIdx

    let section = {
      id: uid++,
      sectionIndex: sectionIndex++,
      index: groupingKeys ? index++ : index,
      //
      type: 'group',
      isSection: true,
      value: group,
      height: 43
    }
    if (groupingKeys) {
      listGroups.push(section)
      listItems.push(section)
    }

    let indexWithinGroup = 0
    let indexWithinType = 0

    groupedItems[groupKey] = groupedItems[groupKey].sort((a, b) => {
      if (a.isCargo === b.isCargo) {
        return a.orderData.priority > b.orderData.priority ? -1 : 1
      }
      return a.isCargo ? 1 : -1
    })
    const startPersonIndex = groupedItems[groupKey].findIndex(item => !item.isCargo)
    const startCargoIndex = groupedItems[groupKey].findIndex(item => item.isCargo)
    // TODO: insert header to list before cargoes and before persons

    const groupSize = groupedItems[groupKey].length
    for (let i = 0; i < groupSize; i++) {
      let item = groupedItems[groupKey][i]

      if (i === startPersonIndex || i === startCargoIndex) {
        indexWithinType = 0
        let header = {
          id: uid++,
          sectionIndex,
          index: index++,
          //
          headersIndex,
          type: (i === startPersonIndex) ? 'personHeader' : 'cargoHeader',
          height: 70
        }
        listItems.push(header)
      }

      let type = item.isCargo ? 'cargo' : 'person'
      let listItem = {
        id: uid++,
        index: index++,
        itemIndex: itemIndex++,
        groupKey: groupKey,
        indexWithinGroup: indexWithinGroup++,
        indexWithinType: indexWithinType++,
        type,
        value: item,
        // searchString: getSearchString(item),
        section, // TODO: add sectionIndex only
        recentlyUpdated: item.recentlyUpdated,
        selected: false,
        inactive: item.inactive,
        height: itemSize,
        size
      }

      if (i === groupSize - 1) {
        listItem.isLastInGroup = true
        // listItem.height = listItem.height * 2
      }
      listItems.push(listItem)
    }
  }
  return {
    groups: groupingKeys ? listGroups : null,
    items: listItems
  }
}

/**
 * returns array with indexed flight orders and search strings
 * FIXME: remove indexes or flight orders?
 * @param fligthOrders
 * @returns {*}
 */
export function makeSearchStrings (fligthOrders, toLowerCase = true) {
  return fligthOrders.reduce((acc, flightOrder, index) => {
    let searchString = makeSearchString(flightOrder)
    if (toLowerCase) {
      searchString = searchString.toLowerCase()
    }
    acc.push({ index, searchString, flightOrder })
    return acc
  }, [])
}
export function makeSearchString (fligthOrder) {
  let searchStringKeys = (fligthOrder.isCargo) ? ['source', 'contacts', 'dimensions', 'email', 'mvz', 'organization', 'packType', 'depDate', 'name']
    : ['source', 'fullName', 'organization', 'email', 'mvz', 'docNum', 'depDate']

  let searchString = searchStringKeys.map(k => fligthOrder[k]).join(' ')

  return searchString.toLowerCase()
}

export function devGenerateFlightOrders (count) {
  let flightOrders = []
  for (let i = 0; i < count; i++) {
    const flightOrder = devGenerateFlightOrder(null, i)
    flightOrders.push(flightOrder)
  }
  return flightOrders
}

export function devGenerateOrders (count) {
  let flightOrders = []
  for (let i = 0; i < count; i++) {
    const flightOrder = devGenerateOrder()
    flightOrders.push(flightOrder)
  }
  return flightOrders
}

export function devGenerateFlightOrder (isCargo, index) {
  isCargo = isCargo != null ? isCargo : faker.random.boolean()

  let orderData = devGenerateOrder(isCargo)

  let depDate = faker.date.recent(3)
  depDate = new Date(parseInt(depDate.getTime() / (1000 * 60 * 60 * 24)) * 1000 * 60 * 60 * 24)
  let depDateStr = moment(depDate).utc(true).toISOString(true)

  let createDateStr = moment(faker.date.past(5)).utc(true).toISOString()
  let updateDateStr = moment(faker.date.past(2)).utc(true).toISOString()

  // ports
  let depPortId = null
  let arrPortId = null
  {
    const ports = getPorts()
    let strings = ''
    let depPort = ports.find(p => p.labels.searchString.indexOf(orderData.from) >= 0)
    let arrPort = ports.find(p => p.labels.searchString.indexOf(orderData.to) >= 0)
    if (!depPort) {
      strings = orderData.from.toUpperCase().split(/[()]/).map(el => el.trim()).filter(el => el.length > 0)
      let foundPortsFrom = searchPortsWithAny(strings)
      depPort = get(foundPortsFrom, 0)
      depPortId = depPort ? depPort.id : null
    }
    if (!arrPort) {
      strings = orderData.to.toUpperCase().split(/[()]/).map(el => el.trim()).filter(el => el.length > 0)
      let foundPortsTo = searchPortsWithAny(strings)
      arrPort = get(foundPortsTo, 0)
      arrPortId = arrPort ? arrPort.id : null
    }
  }

  // see hack for reactivity: https://forum.vuejs.org/t/how-to-make-a-simple-reactive-object-that-can-be-shared-between-components/13199
  let flightOrder = {
    'id': index,
    'depPortId': depPortId,
    'arrPortId': arrPortId,
    'flightDate': depDateStr,
    // initiatorUserId: .....
    orderData,
    'processData': {
      'state': 'FLIGHT-TEST-STATE'
    },
    'cargo': isCargo,
    'source': faker.system.commonFileName('xls', null),
    // 'createUserId': 910,
    'createDate': createDateStr,
    // 'updateUserId': null,
    'updateDate': updateDateStr,
    'workflowProcess': {
      'id': 472,
      'entityType': 'ORDER',
      'entityId': 50,
      'processDefinitionKey': 'flightOrderProcess',
      'processDefinitionId': 'flightOrderProcess:10:617722',
      'processInstanceId': '637501',
      'status': 'COMPLETED'
    },
    'type': 'ORDER'
  }
  // let tmpVm = new Vue({ data: { flightOrder } })
  // flightOrder = tmpVm.flightOrder
  return FlightOrder.assign(flightOrder)
}
export function devGenerateOrder (isCargo) {
  isCargo = isCargo !== undefined ? isCargo : faker.random.boolean()

  let gender = faker.random.number(1)
  let firstName = faker.name.firstName(gender)
  let lastName = faker.name.lastName(gender)

  let x = faker.random.number(9) * 100
  let y = faker.random.number(9) * 100
  let z = faker.random.number(9) * 100
  let dimensions = `${x}x${y}x${z}`

  let depDate = faker.date.recent(2)
  depDate = new Date(parseInt(depDate.getTime() / (1000*60*60*24)) * 1000*60*60*24)

  let from = portNames[faker.random.number(portNames.length - 1)]
  let to
  do {
    to = portNames[faker.random.number(portNames.length - 1)]
  } while (from === to)

  let name = names[faker.random.number(names.length - 1)]
  let packType = packTypes[faker.random.number(packTypes.length - 1)]
  let organization = organizations[faker.random.number(organizations.length - 1)]

  return !isCargo ? {
    // 'depDate': depDate,
    'from': from,
    'to': to,
    // 'source': faker.system.commonFileName('xls', null),
    'firstName': firstName,
    'lastName': lastName,
    'fullName': faker.name.findName(firstName, lastName, gender),
    'organization': organization,
    'email': faker.internet.email(),
    'docNum': faker.finance.account(),
    'birthDate': faker.date.past(50),
    'avatar': faker.internet.avatar(),
    'initiator': {
      'email': faker.internet.email(),
      'username': faker.internet.userName(),
    }
  } : {
    'depDate': depDate,
    'from': from,
    'to': to,
    'source': faker.system.commonFileName('xls', null),
    'contacts': faker.phone.phoneNumber(),
    'dimensions': dimensions,
    'email': faker.internet.email(),
    'isCargo': true,
    'mvz': null,
    'name': name,
    'orderId': faker.random.number(9999),
    'organization': organization,
    'packType': packType,
    'placeCount': faker.random.number(10),
    'transportType': 'внутри грузовой кабины',
    'weight': faker.random.number(5) * 100
  }
}

const portNames = ['НУР (Новый Уренгой)',
  'МКМ (ПСП п.Мыс Каменный)',
  'ВЖК (Новопортовское НГКМ)',
  // 'ССМ (Северо-Самбургское НГКМ)',
]

const names = ['Оборудование',
  'ЗИП',
  'Железяки',
  'ЕДА',
  'Металл',
  'Бумага',
  'Запасные части',
  'Продукты',
  'ЗПЧ',
  'Электроды',
  'Изоляторы',
  'Трубы',
  'Болты',
  'Стройматериалы',
  'Крепеж']

const packTypes = ['Коробка',
  'мешок',
  'ящик']

const organizations = ['ООО ГПН-Ямал',
  'ООО ННГА',
  'ООО ТАЛСПЕЦСТРОЙ',
  'АО ЕПРС',
  'ООО БКЕ',
  'ООО Партнеры Ноябрьск',
  'ООО ННГА',
  'ООО НИИ ЭиРИПР',
  'ООО ЭРИЭЛЛ Нефтегазсервис',
  'ООО КХМ']



// WEBPACK FOOTER //
// ./src/components/flight-orders/scrolled/flightOrdersData.js